module.exports = __webpack_public_path__ + "static/media/screenshot_phone.82590f14.png";